import React from 'react';

import Skeleton from '@liquidweb-dev/undercurrent/Skeleton';

import Stack from '@liquidweb-dev/undercurrent/Stack';
import DrawerContent from '@liquidweb-dev/undercurrent/DrawerContent';
import DrawerFooter from '@liquidweb-dev/undercurrent/DrawerFooter';
import Wrapper from './Wrapper';

/** @param {import('@liquidweb-dev/undercurrent/Drawer').DrawerProps} props */
const Loading = (props) => (
	<Wrapper {...props}>
		<DrawerContent>
			<Stack
				sx={{
					gap: 200,
				}}
			>
				<Skeleton variant="rounded" sx={{ height: '455px', width: '100%' }} />
			</Stack>
		</DrawerContent>
		<DrawerFooter sx={{ gap: 100 }}>
			<Skeleton
				variant="rounded"
				sx={{ height: ({ size }) => size.lg, width: '100%' }}
			/>
			<Skeleton
				variant="rounded"
				sx={{ height: ({ size }) => size.lg, width: '100%' }}
			/>
		</DrawerFooter>
	</Wrapper>
);

export default Loading;
